import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type ListItemContainerElement = FlexElement;

export interface ListItemContainerProps extends FlexProps {}

export const ListItemContainer = styled(Flex).withConfig({
  displayName: 'ListItemContainer',
})<ListItemContainerProps>`
  padding: var(--spacing-gap) calc(var(--spacing-gap) * 1.5);
  align-items: center;
  gap: calc(var(--spacing-gap) * 2);
  min-height: calc(var(--spacing-gap) * 9);
`;
